import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY} from "../../../base";
import Endpoints from "../../../domain/endpoints";
import Swal from "sweetalert2";
import { ApproveCustomer } from "../../../domain/useages/customer-database/approve-customer";
import { RemoteApproveCustomer } from "../../../data/usecases/customer-database/remote-approve-customer";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface ApproveCustomerInterface {
  approveCustomer: Function;
  handleApproveLoading: Function;
}

const initialStates = {};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useApproveCustomerSlice: StateCreator<ApproveCustomerInterface> = (
  set,
  get
) => ({
  ...initialStates,
  handleApproveLoading: (value: boolean) => {
    if (value) {
      Swal.fire({
        didOpen: () => {
          if (value) {
            Swal.showLoading();
          }
        },
        customClass: {
          container: "swal2-style",
        },
        title: "Please wait... Approved customer request is sending ",
      });
    }
  },

  approveCustomer: async (payload: ApproveCustomer.Params) => {
   const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
   const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);
    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });
    const remoteApproveCustomer: ApproveCustomer = new RemoteApproveCustomer(
      `${BASE_URL}${Endpoints.APPROVE_CUSTOMER}`,

      axiosHttpClient
    );
    let response = await remoteApproveCustomer.update(payload);
    return response;
  },
});
